var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.cur_item)
    ? _c("div", { staticClass: "categ_info" }, [
        !_vm.is_set_data
          ? _c(
              "div",
              { staticClass: "redraw_block" },
              [
                _c("info_field", {
                  attrs: {
                    f_uniq: "ct3",
                    f_type: "group_name",
                    is_disabled: true,
                    f_title: _vm.__t("PWA.ACTION_GROUP"),
                    f_val: _vm.active_group_title,
                  },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "ct1",
                    f_type: "title",
                    is_disabled: false,
                    f_title: _vm.__t("NAME"),
                    f_val: _vm.cur_item.title,
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                !_vm.is_catalog
                  ? _c("info_field", {
                      attrs: {
                        f_uniq: "ct2",
                        f_type: "cart_title",
                        is_disabled: false,
                        f_title: _vm.__t("PWA.NAME"),
                        f_val: _vm.cur_item.cart_title,
                      },
                      on: { update_categ: _vm.change_atr },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_catalog
                  ? _c("info_field", {
                      attrs: {
                        f_uniq: "ct",
                        f_type: "min_sum",
                        is_disabled: false,
                        f_title: _vm.__t("PWA.MIN_SUM"),
                        f_val: _vm.cur_item.min_sum,
                      },
                      on: { update_categ: _vm.change_atr },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_promo
                  ? _c(
                      "div",
                      [
                        _c("yes_no", {
                          key: "IS_MULTIPLE",
                          attrs: { title: "IS_MULTIPLE" },
                          on: {
                            input: function (val) {
                              return _vm.change_atr("is_multiple", val)
                            },
                          },
                          model: {
                            value: _vm.cur_item.is_multiple,
                            callback: function ($$v) {
                              _vm.$set(_vm.cur_item, "is_multiple", $$v)
                            },
                            expression: "cur_item.is_multiple",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_promo
                  ? _c("div", { staticClass: "promo_block" }, [
                      !_vm.cur_item.is_multiple
                        ? _c(
                            "div",
                            { staticClass: "simple_promo" },
                            [
                              _vm.active_group.type === "promo"
                                ? _c("info_field", {
                                    attrs: {
                                      f_uniq: "ct",
                                      f_type: "min_sum",
                                      is_disabled: false,
                                      f_title: _vm.__t("PWA.PROMOCODE"),
                                      f_val: _vm.cur_item.promocode,
                                    },
                                    on: {
                                      input: function (val) {
                                        return _vm.change_atr("promocode", val)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "before_load" },
                              [
                                _c(
                                  "h1",
                                  { staticClass: "display-5 fw-bold mt-3" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.__t("UPLOAD_FILE")) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("fileload", {
                                  attrs: {
                                    doc_id: _vm.cur_item.id,
                                    doc_type: "action",
                                    url_load: "pos/upload/feed",
                                  },
                                  on: { finish_load: _vm.finish_load },
                                }),
                              ],
                              1
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "allow_in" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c(
                            "div",
                            [
                              _c("yes_no", {
                                key: "PUBLISHED",
                                attrs: { title: "PUBLISHED" },
                                on: {
                                  input: function (val) {
                                    return _vm.change_atr("published", val)
                                  },
                                },
                                model: {
                                  value: _vm.cur_item.published,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cur_item, "published", $$v)
                                  },
                                  expression: "cur_item.published",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        !_vm.is_delivery && !_vm.is_catalog
                          ? _c("b-col", [
                              _c(
                                "div",
                                [
                                  _c("yes_no", {
                                    key: "IN_DELIVERY",
                                    attrs: { title: "IN_DELIVERY" },
                                    on: {
                                      input: function (val) {
                                        return _vm.change_atr(
                                          "in_delivery",
                                          val
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.cur_item.in_delivery,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cur_item,
                                          "in_delivery",
                                          $$v
                                        )
                                      },
                                      expression: "cur_item.in_delivery",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.is_delivery && !_vm.is_catalog
                          ? _c("b-col", [
                              _c(
                                "div",
                                [
                                  _c("yes_no", {
                                    key: "IN_PICKUP",
                                    attrs: { title: "IN_PICKUP" },
                                    on: {
                                      input: function (val) {
                                        return _vm.change_atr("in_pickup", val)
                                      },
                                    },
                                    model: {
                                      value: _vm.cur_item.in_pickup,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.cur_item, "in_pickup", $$v)
                                      },
                                      expression: "cur_item.in_pickup",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.is_catalog
                  ? _c("div", { staticClass: "form-group mt-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "linked_rest" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.__t("FILTER_RESTAURANTS")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.restaurants.length > 0
                        ? _c(
                            "div",
                            {},
                            [
                              _c(
                                "v-select",
                                {
                                  staticClass: "imc_reasons",
                                  attrs: {
                                    multiple: "",
                                    id: "linked_rest",
                                    label: "title",
                                    reduce: function (rest) {
                                      return rest.id
                                    },
                                    filter: _vm.searchRest,
                                    options: _vm.restaurants,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (option) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "d-center" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(option.title) +
                                                      "\n                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(option.uniq_id) +
                                                        " " +
                                                        _vm._s(option.address) +
                                                        "\n                                "
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4139232694
                                  ),
                                  model: {
                                    value: _vm.action.rest_ids,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.action, "rest_ids", $$v)
                                    },
                                    expression: "action.rest_ids",
                                  },
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.__t("CHOOSE_POS_REST")) +
                                        "\n                    "
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.is_catalog
                  ? _c("div", { staticClass: "form-group mt-4" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "linked_rest" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.__t("FILTER_LOCATIONS")) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.locations.length > 0
                        ? _c(
                            "div",
                            {},
                            [
                              _c(
                                "v-select",
                                {
                                  staticClass: "imc_reasons",
                                  attrs: {
                                    multiple: "",
                                    id: "linked_rest",
                                    label: "title",
                                    reduce: function (rest) {
                                      return rest.id
                                    },
                                    filter: _vm.searchRest,
                                    options: _vm.locations,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (option) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "d-center" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(option.title) +
                                                      "\n                            "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(option.uniq_id) +
                                                        " " +
                                                        _vm._s(option.address) +
                                                        "\n                                "
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4139232694
                                  ),
                                  model: {
                                    value: _vm.action.rest_ids,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.action, "rest_ids", $$v)
                                    },
                                    expression: "action.rest_ids",
                                  },
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.__t("CHOOSE_POS_REST")) +
                                        "\n                    "
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }